import { useEffect, useMemo } from "react";
import { ensureCatalogAuth } from "../../../services/backend/authService";
import { getAlmacenes } from "../../../services/backend/catalogService";

const useWarehouseData = ({ almacenes, setAlmacenes, selectedAlmacen, setSelectedAlmacen }) => {
  const warehouseOptions = useMemo(
    () => (Array.isArray(almacenes) ? almacenes : [])
      .map((item) => ({
        label: String(item?.sucursal || item?.almacen || "").trim(),
        value: String(item?.almacen || "").trim(),
      }))
      .filter((item) => item.label && item.value),
    [almacenes]
  );

  useEffect(() => {
    let isCurrent = true;

    if (warehouseOptions.length) {
      return undefined;
    }

    const loadAlmacenes = async () => {
      try {
        await ensureCatalogAuth();
        const response = await getAlmacenes();
        if (!isCurrent) {
          return;
        }
        const nextAlmacenes = Array.isArray(response?.sucursales) ? response.sucursales : [];
        setAlmacenes(nextAlmacenes);
        if (!selectedAlmacen && nextAlmacenes[0]?.almacen) {
          setSelectedAlmacen(nextAlmacenes[0].almacen);
        }
      } catch {
        if (isCurrent) {
          setAlmacenes([]);
        }
      }
    };

    loadAlmacenes();

    return () => {
      isCurrent = false;
    };
  }, [warehouseOptions.length, setAlmacenes, selectedAlmacen, setSelectedAlmacen]);

  useEffect(() => {
    if (!warehouseOptions.length) {
      return;
    }
    const hasSelectedWarehouse = warehouseOptions.some((item) => item.value === selectedAlmacen);
    if (!hasSelectedWarehouse) {
      setSelectedAlmacen(warehouseOptions[0].value);
    }
  }, [warehouseOptions, selectedAlmacen, setSelectedAlmacen]);

  return { warehouseOptions };
};

export default useWarehouseData;